export const STORE_RATING = 4.8;
export const STORE_REVIEW_COUNT = 40_000;

type StoreProofTranslationValues = {
  rating: string;
  reviewCount: string;
};

const getNumberFormatter = (
  locale: string | undefined,
  options?: Intl.NumberFormatOptions,
): Intl.NumberFormat => {
  try {
    return new Intl.NumberFormat(locale || "en", options);
  } catch {
    return new Intl.NumberFormat("en", options);
  }
};

// Store proof changes over time. Keep the source numbers here and let every
// translated surface decide only the surrounding grammar and word order.
export const getStoreProofTranslationValues = (
  locale?: string,
): StoreProofTranslationValues => ({
  rating: getNumberFormatter(locale, {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  }).format(STORE_RATING),
  reviewCount: getNumberFormatter(locale).format(STORE_REVIEW_COUNT),
});
